import React from 'react';
import VideoUploaderForStyleSettings from 'components/VideoUploader/VideoUploaderForStyleSettings';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ThumbItem.module.scss';

interface IThumbVideoItem {
	onClick: () => void;
	selected: boolean;
	isMakeRequest: boolean;
	translationId: string;
	filePath?: Nullable<string>;
}

const ThumbVideoItem: React.FC<IThumbVideoItem> = ({
	onClick,
	selected,
	isMakeRequest,
	translationId,
	filePath = null,
}) => {
	return (
		<div className={`${style.emblaSlide} ${style.emblaSlideThumb} ${selected ? style.isSelected : ''}`}>
			<button
				onClick={onClick}
				className={`${style.emblaSlideInner} ${style.emblaSlideInnerThumb}`}
				type="button">
				<span className={style.emblaSlideThumbnailDiv}>
					<VideoUploaderForStyleSettings
						translationID={translationId}
						isMakeImageRequest={isMakeRequest}
						loaderSize="big"
						isShowControls={false}
						filePath={selected ? filePath : null}
					/>
				</span>
				<div className={style.overlayForThumb}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#playBtn`} />
					</svg>
				</div>
			</button>
		</div>
	);
};

export default React.memo(ThumbVideoItem);
